export const USER_ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  TECHNICIAN: 'technician',
  TECHNICAL: 'technical',
  BILLING: 'billing',
  ACCOUNTANT: 'accountant',
  CASHIER: 'cashier',
  MD: 'md',
  OPS_MANAGER: 'ops_manager',
  HR: 'hr',
  STORE: 'store',
  CUSTOMER_CARE: 'customer_care',
  PROCUREMENT: 'procurement',
  LOGISTICS: 'logistics',
  RECEPTIONIST: 'receptionist',
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Administrator',
  manager: 'Manager',
  technician: 'Technician',
  technical: 'Technical Manager',
  billing: 'Billing Officer',
  accountant: 'Accountant',
  cashier: 'Cashier',
  md: 'Managing Director',
  ops_manager: 'Operations Manager',
  hr: 'HR Manager',
  store: 'Store Officer',
  customer_care: 'Customer Care',
  procurement: 'Procurement Officer',
  logistics: 'Logistics & Transport',
  receptionist: 'Receptionist',
};
